// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/company_construction_types.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/company_construction_types.proto.
 */
export const file_api_proto_v1_company_construction_types: GenFile = /*@__PURE__*/
  fileDesc("Ci1hcGlfcHJvdG8vdjEvY29tcGFueV9jb25zdHJ1Y3Rpb25fdHlwZXMucHJvdG8SDGFwaV9wcm90by52MSKnAQoXQ29tcGFueUNvbnN0cnVjdGlvblR5cGUSEgoKY29tcGFueV9pZBgBIAEoAxIeChZjb25zdHJ1Y3Rpb25fdHlwZV9uYW1lGAIgASgJEisKB2NyZWF0ZWQYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEisKB3VwZGF0ZWQYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIloKJENyZWF0ZUNvbXBhbnlDb25zdHJ1Y3Rpb25UeXBlUmVxdWVzdBISCgpjb21wYW55X2lkGAEgASgDEh4KFmNvbnN0cnVjdGlvbl90eXBlX25hbWUYAiABKAkicQolQ3JlYXRlQ29tcGFueUNvbnN0cnVjdGlvblR5cGVSZXNwb25zZRJIChljb21wYW55X2NvbnN0cnVjdGlvbl90eXBlGAEgASgLMiUuYXBpX3Byb3RvLnYxLkNvbXBhbnlDb25zdHJ1Y3Rpb25UeXBlIloKJFVwZGF0ZUNvbXBhbnlDb25zdHJ1Y3Rpb25UeXBlUmVxdWVzdBISCgpjb21wYW55X2lkGAEgASgDEh4KFmNvbnN0cnVjdGlvbl90eXBlX25hbWUYAiABKAkicQolVXBkYXRlQ29tcGFueUNvbnN0cnVjdGlvblR5cGVSZXNwb25zZRJIChljb21wYW55X2NvbnN0cnVjdGlvbl90eXBlGAEgASgLMiUuYXBpX3Byb3RvLnYxLkNvbXBhbnlDb25zdHJ1Y3Rpb25UeXBlIloKJERlbGV0ZUNvbXBhbnlDb25zdHJ1Y3Rpb25UeXBlUmVxdWVzdBISCgpjb21wYW55X2lkGAEgASgDEh4KFmNvbnN0cnVjdGlvbl90eXBlX25hbWUYAiABKAkiJwolRGVsZXRlQ29tcGFueUNvbnN0cnVjdGlvblR5cGVSZXNwb25zZSJXCiFHZXRDb21wYW55Q29uc3RydWN0aW9uVHlwZVJlcXVlc3QSEgoKY29tcGFueV9pZBgBIAEoAxIeChZjb25zdHJ1Y3Rpb25fdHlwZV9uYW1lGAIgASgJImYKIkdldENvbXBhbnlDb25zdHJ1Y3Rpb25UeXBlUmVzcG9uc2USQAoRY29uc3RydWN0aW9uX3R5cGUYASABKAsyJS5hcGlfcHJvdG8udjEuQ29tcGFueUNvbnN0cnVjdGlvblR5cGUiXAolR2V0Q29tcGFueUNvbnN0cnVjdGlvblR5cGVMaXN0UmVxdWVzdBISCgpjb21wYW55X2lkGAEgASgDEgwKBHBhZ2UYAiABKAMSEQoJcGFnZV9zaXplGAMgASgDIpwBCiZHZXRDb21wYW55Q29uc3RydWN0aW9uVHlwZUxpc3RSZXNwb25zZRJJChpjb21wYW55X2NvbnN0cnVjdGlvbl90eXBlcxgBIAMoCzIlLmFwaV9wcm90by52MS5Db21wYW55Q29uc3RydWN0aW9uVHlwZRITCgt0b3RhbF9jb3VudBgCIAEoAxISCgp0b3RhbF9wYWdlGAMgASgDQjNaMWdpdGh1Yi5jb20vaC1zY2FwZS9pZXNhcHVyaS9nby9hcGlfcHJvdG8vdjE7YXBpdjFiBnByb3RvMw", [file_google_protobuf_timestamp]);

/**
 * 企業工種の紐付け
 *
 * @generated from message api_proto.v1.CompanyConstructionType
 */
export type CompanyConstructionType = Message<"api_proto.v1.CompanyConstructionType"> & {
  /**
   * 会社ID
   *
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * 工種名
   *
   * @generated from field: string construction_type_name = 2;
   */
  constructionTypeName: string;

  /**
   * @generated from field: google.protobuf.Timestamp created = 3;
   */
  created?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated = 4;
   */
  updated?: Timestamp;
};

/**
 * Describes the message api_proto.v1.CompanyConstructionType.
 * Use `create(CompanyConstructionTypeSchema)` to create a new message.
 */
export const CompanyConstructionTypeSchema: GenMessage<CompanyConstructionType> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_construction_types, 0);

/**
 * 企業工種紐付け作成リクエスト
 *
 * @generated from message api_proto.v1.CreateCompanyConstructionTypeRequest
 */
export type CreateCompanyConstructionTypeRequest = Message<"api_proto.v1.CreateCompanyConstructionTypeRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * @generated from field: string construction_type_name = 2;
   */
  constructionTypeName: string;
};

/**
 * Describes the message api_proto.v1.CreateCompanyConstructionTypeRequest.
 * Use `create(CreateCompanyConstructionTypeRequestSchema)` to create a new message.
 */
export const CreateCompanyConstructionTypeRequestSchema: GenMessage<CreateCompanyConstructionTypeRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_construction_types, 1);

/**
 * 企業工種紐付け作成レスポンス
 *
 * @generated from message api_proto.v1.CreateCompanyConstructionTypeResponse
 */
export type CreateCompanyConstructionTypeResponse = Message<"api_proto.v1.CreateCompanyConstructionTypeResponse"> & {
  /**
   * @generated from field: api_proto.v1.CompanyConstructionType company_construction_type = 1;
   */
  companyConstructionType?: CompanyConstructionType;
};

/**
 * Describes the message api_proto.v1.CreateCompanyConstructionTypeResponse.
 * Use `create(CreateCompanyConstructionTypeResponseSchema)` to create a new message.
 */
export const CreateCompanyConstructionTypeResponseSchema: GenMessage<CreateCompanyConstructionTypeResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_construction_types, 2);

/**
 * 企業工種紐付け作成リクエスト
 *
 * @generated from message api_proto.v1.UpdateCompanyConstructionTypeRequest
 */
export type UpdateCompanyConstructionTypeRequest = Message<"api_proto.v1.UpdateCompanyConstructionTypeRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * @generated from field: string construction_type_name = 2;
   */
  constructionTypeName: string;
};

/**
 * Describes the message api_proto.v1.UpdateCompanyConstructionTypeRequest.
 * Use `create(UpdateCompanyConstructionTypeRequestSchema)` to create a new message.
 */
export const UpdateCompanyConstructionTypeRequestSchema: GenMessage<UpdateCompanyConstructionTypeRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_construction_types, 3);

/**
 * 企業工種紐付け作成レスポンス
 *
 * @generated from message api_proto.v1.UpdateCompanyConstructionTypeResponse
 */
export type UpdateCompanyConstructionTypeResponse = Message<"api_proto.v1.UpdateCompanyConstructionTypeResponse"> & {
  /**
   * @generated from field: api_proto.v1.CompanyConstructionType company_construction_type = 1;
   */
  companyConstructionType?: CompanyConstructionType;
};

/**
 * Describes the message api_proto.v1.UpdateCompanyConstructionTypeResponse.
 * Use `create(UpdateCompanyConstructionTypeResponseSchema)` to create a new message.
 */
export const UpdateCompanyConstructionTypeResponseSchema: GenMessage<UpdateCompanyConstructionTypeResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_construction_types, 4);

/**
 * 企業工種紐付け削除リクエスト
 *
 * @generated from message api_proto.v1.DeleteCompanyConstructionTypeRequest
 */
export type DeleteCompanyConstructionTypeRequest = Message<"api_proto.v1.DeleteCompanyConstructionTypeRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * @generated from field: string construction_type_name = 2;
   */
  constructionTypeName: string;
};

/**
 * Describes the message api_proto.v1.DeleteCompanyConstructionTypeRequest.
 * Use `create(DeleteCompanyConstructionTypeRequestSchema)` to create a new message.
 */
export const DeleteCompanyConstructionTypeRequestSchema: GenMessage<DeleteCompanyConstructionTypeRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_construction_types, 5);

/**
 * 企業工種紐付け削除レスポンス
 *
 * @generated from message api_proto.v1.DeleteCompanyConstructionTypeResponse
 */
export type DeleteCompanyConstructionTypeResponse = Message<"api_proto.v1.DeleteCompanyConstructionTypeResponse"> & {
};

/**
 * Describes the message api_proto.v1.DeleteCompanyConstructionTypeResponse.
 * Use `create(DeleteCompanyConstructionTypeResponseSchema)` to create a new message.
 */
export const DeleteCompanyConstructionTypeResponseSchema: GenMessage<DeleteCompanyConstructionTypeResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_construction_types, 6);

/**
 * 企業工種紐付け詳細取得リクエスト
 *
 * @generated from message api_proto.v1.GetCompanyConstructionTypeRequest
 */
export type GetCompanyConstructionTypeRequest = Message<"api_proto.v1.GetCompanyConstructionTypeRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * @generated from field: string construction_type_name = 2;
   */
  constructionTypeName: string;
};

/**
 * Describes the message api_proto.v1.GetCompanyConstructionTypeRequest.
 * Use `create(GetCompanyConstructionTypeRequestSchema)` to create a new message.
 */
export const GetCompanyConstructionTypeRequestSchema: GenMessage<GetCompanyConstructionTypeRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_construction_types, 7);

/**
 * 企業工種紐付け詳細取得レスポンス
 *
 * @generated from message api_proto.v1.GetCompanyConstructionTypeResponse
 */
export type GetCompanyConstructionTypeResponse = Message<"api_proto.v1.GetCompanyConstructionTypeResponse"> & {
  /**
   * @generated from field: api_proto.v1.CompanyConstructionType construction_type = 1;
   */
  constructionType?: CompanyConstructionType;
};

/**
 * Describes the message api_proto.v1.GetCompanyConstructionTypeResponse.
 * Use `create(GetCompanyConstructionTypeResponseSchema)` to create a new message.
 */
export const GetCompanyConstructionTypeResponseSchema: GenMessage<GetCompanyConstructionTypeResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_construction_types, 8);

/**
 * 企業工種紐付けリスト取得リクエスト
 *
 * @generated from message api_proto.v1.GetCompanyConstructionTypeListRequest
 */
export type GetCompanyConstructionTypeListRequest = Message<"api_proto.v1.GetCompanyConstructionTypeListRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * @generated from field: int64 page = 2;
   */
  page: bigint;

  /**
   * @generated from field: int64 page_size = 3;
   */
  pageSize: bigint;
};

/**
 * Describes the message api_proto.v1.GetCompanyConstructionTypeListRequest.
 * Use `create(GetCompanyConstructionTypeListRequestSchema)` to create a new message.
 */
export const GetCompanyConstructionTypeListRequestSchema: GenMessage<GetCompanyConstructionTypeListRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_construction_types, 9);

/**
 * 企業工種紐付けリスト取得レスポンス
 *
 * @generated from message api_proto.v1.GetCompanyConstructionTypeListResponse
 */
export type GetCompanyConstructionTypeListResponse = Message<"api_proto.v1.GetCompanyConstructionTypeListResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.CompanyConstructionType company_construction_types = 1;
   */
  companyConstructionTypes: CompanyConstructionType[];

  /**
   * @generated from field: int64 total_count = 2;
   */
  totalCount: bigint;

  /**
   * @generated from field: int64 total_page = 3;
   */
  totalPage: bigint;
};

/**
 * Describes the message api_proto.v1.GetCompanyConstructionTypeListResponse.
 * Use `create(GetCompanyConstructionTypeListResponseSchema)` to create a new message.
 */
export const GetCompanyConstructionTypeListResponseSchema: GenMessage<GetCompanyConstructionTypeListResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_construction_types, 10);

